import { environment as base } from './environment';
import { apiUrls } from './api-urls';
import type { Environment } from './environment';

export const environment: Environment = {
  ...base,
  apiProxyUrl: 'https://api-stg.uhg.com/api/pdr/msr/uhci-aws-core-api-test/v2.0.0/',
  ssoApiProxyUrl: 'https://uhci-ui-internal-test.optum.com/',
  postLoginProxyUrl: '/uhci/login/int/',
  originUrl: '/',
  redirectUri: 'https://uhci-ui-internal-test.optum.com/',
  domain: '.uhc.com',
  domainEnvironment: ['https://uhcinsights-internal-int.uhc.com'],
  cookieEnvironment: 'INT_',
  featureFlagUrl: 'https://api-stg.uhg.com/api/pdr/msr/uhci-aws-pnb-api-test/v2.0.0/pnb/feature-flags/',
  upstreamEnv: 'test',
  goldCardEnvironment: 'test',
  goldCardabyssparcelUrl: 'https://uhci-ui-internal-test.optum.com/abyss-parcel.js',
  qualtricksEnvCheck: 'test',
  clickStreamUrl:
    'https://assets.adobedtm.com/512027f42d3c/c18a9fa8e51b/launch-ENacdc6d1acf734bcd95703e446bd1de1d-development.min.js',
  production: false,
  staging: true,
  apiUrls: {
    ...apiUrls,
    bulkTinRUrl: 'https://api-stg.uhg.com/api/pdr/msr/uhci-aws-bulk-process-api-test/v2.0.0/',
    SsoRedirectUri:
      'https://stage-sso.uhc.com/ext/as/authorization.oauth2?pfidpadapterid=OptumIdOIDCStage&client_id=PED42235&response_' +
      'type=code&redirect_uri=https://uhci-ui-internal-test.optum.com/login&scope=openid+profile+email&state=PED&prompt=none',
    SsoRedirectLogin:
      'https://identity.nonprod.onehealthcareid.com/oidc/authorize?client_id=PED42235&response_type=code' +
      '&redirect_uri=https://uhci-ui-internal-test.optum.com/login&scope=openid+profile+email&state=PED&prompt=login',
    SsoLogoutUrl:
      'https://identity.nonprod.onehealthcareid.com/oidc/logout?id_token_hint=id_token_hint_delimiter&post_logout_' +
      'redirect_uri=' +
      window.location.origin,
    linkLoginPage: 'https://provider-stage.linkhealth.com',
    providerLoginPage: 'https://secure-nonprod.uhcprovider.com/stage/#/',
  },
};
